import { render, staticRenderFns } from "./ClockComponent.vue?vue&type=template&id=4f7e314f&"
import script from "./ClockComponent.vue?vue&type=script&lang=js&"
export * from "./ClockComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports